module.exports = __webpack_public_path__ + "media/img/corporate/logos/pwc-0a3aa0a739f27a9873fe1e308c199235.svg";